import { createFileRoute } from "@tanstack/react-router";
import { parse, format, isValid } from "date-fns";
import { es } from "date-fns/locale";
import ResultadosFecha from "@/pages/ResultadosFecha";
import { lotteryResultsByDateQuery } from "@/hooks/useLotteryResults";

const pretty = (fecha: string) => {
  const d = parse(fecha, "yyyy-MM-dd", new Date());
  return isValid(d) ? format(d, "d 'de' MMMM 'de' yyyy", { locale: es }) : fecha;
};

export const Route = createFileRoute("/resultados/$fecha")({
  loader: async ({ context, params }) => {
    const d = parse(params.fecha, "yyyy-MM-dd", new Date());
    if (!isValid(d)) return;
    try {
      await context.queryClient.ensureQueryData(lotteryResultsByDateQuery(d));
    } catch {
      // client will retry
    }
  },
  head: ({ params }) => {
    const f = pretty(params.fecha);
    const title = `Nica y Tica ${f}: resultados Loto Diaria y Nuevos Tiempos | TiemposHoy`;
    const description = `¿Qué salió el ${f}? Resultados de la Loto Diaria de Nicaragua y Nuevos Tiempos (JPS) de Costa Rica, sorteo por sorteo.`;
    const url = `https://tiemposhoy.com/resultados/${params.fecha}`;
    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { name: "twitter:card", content: "summary" },
        { property: "og:url", content: url },
      ],
      links: [{ rel: "canonical", href: url }],
    };
  },
  component: ResultadosFecha,
});
